import React, { useRef } from "react";
import { FormGroup, FormControl, ControlLabel, Button, Glyphicon } from "react-bootstrap";

export default ({ block, onSaveFile }) => {
    const imageInputRef = useRef(null);

    return (
        <FormGroup>
            <ControlLabel>{block.imageUrl ? "Изменить" : "Добавить"} изображение</ControlLabel>
            {block.imageUrl && <div><img src={block.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
            <div>
                <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
            </div>
            <FormControl
                type="file"
                onChange={(e) => onSaveFile('image', e.target.files[0] || null)}
                inputRef={ref => imageInputRef.current = ref}
                style={{ display: 'none' }}
            />
        </FormGroup>
    )
};
